<template>
  <app-page labelledby="legacy-account-title">
    <page-header
      title-id="legacy-account-title"
      title="Расчетные счета"
      description="Управление банковскими счетами перенесено в единый реестр бухгалтерии."
    />
    <app-state
      state="unavailable"
      title="Используйте реестр расчетных счетов"
      message="Старая форма не сохраняла данные и больше не используется. Откройте действующий реестр банковских счетов."
      action-label="Открыть расчетные счета"
      :action-to="{ name: 'bank_accounts_list' }"
      data-testid="legacy-account-bills-state"
    />
  </app-page>
</template>

<script>
import AppPage from '../../components/ui/AppPage.vue'
import AppState from '../../components/ui/AppState.vue'
import PageHeader from '../../components/ui/PageHeader.vue'

export default {
  name: 'LegacyAccountBills',
  components: { AppPage, AppState, PageHeader }
}
</script>
